import axios from 'axios';
import { checkAndRecordApiCall } from './util/apiThrottle';

let accessToken = null;
const USE_DEV2 = import.meta.env.PUBLIC_USE_DEV2 === "true";

export const setApiAccessToken = (newToken) => {
  accessToken = newToken;
};

const apiClient = axios.create({
  baseURL: import.meta.env.PUBLIC_API_URL,
  headers: {
    "Content-Type": "application/json",
    "dev2": USE_DEV2 ? "true" : "false",
  },
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  if (USE_DEV2) {
    config.headers.dev2 = `true`;
    config.headers["dev2"] = `true`;
  }
  return config;
});


apiClient.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

apiClient.interceptors.request.use((config) => {
  if (!config.url.includes(import.meta.env.PUBLIC_API_URL))
    config.url = import.meta.env.PUBLIC_API_URL + config.url;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = {
      requestMethod: error.config?.method?.toUpperCase() ?? null,
      requestUrl: error.config?.url ?? null,
      requestQueryParams: error.config?.params ?? null,
      requestHeaders: error.config?.headers ?? null,
      requestResponseType: error.config?.responseType ?? null,
      errorCode: error.code ?? null,
      errorMessage:
        error?.response?.data?.message ??
        error.message ??
        'An error occurred while processing the request.',
      responseStatusCode: error.response?.status ?? error.status ?? null,
      responseBody: error.response?.data ?? null,
    };
    console.error('API Client Error:', errorMessage);
    return Promise.reject(error);
  },
);

/////////////////////BEGIN NEW API THROTTLE WORK//////////////////////
// Dev-only API call tracker to detect duplicate calls during page refresh
if (process.env.NODE_ENV === 'development') {
  const apiCallCounts = new Map();
  window.__apiCallTracker = {
    incr: (key) => apiCallCounts.set(key, (apiCallCounts.get(key) || 0) + 1),
    getAll: () => Array.from(apiCallCounts.entries()),
    dump: () => {
      const results = Array.from(apiCallCounts.entries())
        .map(([k, v]) => ({ call: k, count: v }))
        .sort((a, b) => b.count - a.count);
      // show only duplicates
      const duplicates = results.filter((r) => r.count > 1);
      console.table(duplicates.length ? duplicates : results.slice(0, 50));
      return duplicates.length ? duplicates : results.slice(0, 50);
    },
    reset: () => apiCallCounts.clear(),
  };

  apiClient.interceptors.request.use((config) => {
    try {
      const method = (config.method || 'GET').toUpperCase();
      const params = config.params ? JSON.stringify(config.params) : '';
      const key = `${method} ${config.url} ${params}`;
      window.__apiCallTracker.incr(key);
    } catch (err) {
      // ignore tracker errors
    }
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const method = (error.config?.method || 'GET').toUpperCase();
        const params = error.config?.params ? JSON.stringify(error.config.params) : '';
        const key = `${method} ${error.config?.url} ${params}`;
        window.__apiCallTracker.incr(`${key} (ERROR)`);
      } catch (err) {}
      return Promise.reject(error);
    },
  );
}

// NOTE: Throttle implementation moved to `apiThrottle.js`
apiClient.interceptors.request.use((config) => {
  try {
    //checkAndRecordApiCall(config);
  } catch (err) {
    // Propagate throttle errors as before but include a warning log
    console.warn('apiClient: throttling identical API request', {
      message: err.message,
      key: err.key,
      waitSeconds: err.waitSeconds,
    });
    return Promise.reject(err);
  }

  return config;
});

// Re-export helpers for convenience/compatibility
export {
  clearApiCallRecords,
  getThrottleCount,
  getTotalThrottleCount,
  logApiCallTotals,
  setApiCooldownSeconds,
} from './util/apiThrottle';

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = {
      requestMethod: error.config?.method?.toUpperCase() ?? null,
      requestUrl: error.config?.url ?? null,
      requestQueryParams: error.config?.params ?? null,
      requestHeaders: error.config?.headers ?? null,
      requestResponseType: error.config?.responseType ?? null,
      errorCode: error.code ?? null,
      errorMessage:
        error?.response?.data?.message ??
        error.message ??
        'An error occurred while processing the request.',
      responseStatusCode: error.response?.status ?? error.status ?? null,
      responseBody: error.response?.data ?? null,
    };
    console.error('API Client Error:', errorMessage);
    return Promise.reject(error);
  },
);

export default apiClient;
